import { Link as NextLink } from '@nextui-org/react';
import styled from 'styled-components';

const Link = styled(NextLink).attrs((props) => {
  return {
    css: {
      '&': {
        'font-family': '$dmSans',
        'font-size': '$md',
        'line-height': '$s',
        ...props.css?.['&'],
      },
      ...props.css,
    },
    ...props,
  };
})``;

export default Link;
